/**
 * The small, pure parts of the discussion panel (issue #99, phase B), kept out
 * of the component file so that file exports only a component.
 */

import type { DiscussionThread } from '../../schema'

/** The longest comment the server takes; the same figure as best.git.discussions.MAX_BODY. */
export const MAX_COMMENT = 20_000

/** "path:line" for a thread GitLab anchored to the code; null for a general one. */
export function positionLabel(thread: DiscussionThread): string | null {
  const where = thread.position
  if (!where) return null
  // The new side when there is one: it is the line the person sees in the file.
  const path = where.new_path || where.old_path
  const line = where.new_line ?? where.old_line
  if (!path) return null
  return line !== null && line !== undefined ? `${path}:${line}` : path
}

/** "3 unresolved", or the reassurance that there are none. */
export function unresolvedText(count: number): string {
  return count === 0 ? 'No unresolved discussions' : `${count} unresolved`
}
